export const HB_POPULAR_CACHE = "hb_popular_cache";
export const HB_CHECK_PROMPT = "hb_check_prompt";
export const API_CACHEKEY = {
  BOARD: "API_BOARD",
  USER: "API_USER",
  DOMAIN: "API_DOMAIN",
};
export const HB_FOLLOW_RECOMMEND_TIME = "hb_follow_recommend_time";
export const HB_IMG_RETRY = "hb_img_retry";
